"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemLogger = void 0;
var Logger_1 = require("../shared/Logger");
var AppInfo_1 = require("./AppInfo/AppInfo");
var ELKFormatter_1 = require("./Formatter/ELKFormatter");
var getScriptConfigParams_1 = require("./getScriptConfigParams");
var ConsoleTransport_1 = require("./Transport/ConsoleTransport");
var HTTPTransport_1 = require("./Transport/HTTPTransport");
var logger = null;
function getSystemLogger() {
    if (logger) {
        return logger;
    }
    var scriptConfigParams = (0, getScriptConfigParams_1.getScriptConfigParams)();
    var appInfo = new AppInfo_1.AppInfo(scriptConfigParams.projectName || process.env.PROJECT_NAME);
    var formatter;
    var transport;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        /**
         * TODO: Tree shaking не работает с CommonJS. Необходимо переделать на ES импорты
         */
        var PrettyFormatter = require('@cian/system-logger/shared/Formatter/PrettyFormatter').PrettyFormatter;
        formatter = new PrettyFormatter();
        transport = new ConsoleTransport_1.ConsoleTransport(formatter);
    }
    else {
        formatter = new ELKFormatter_1.ELKFormatter(appInfo);
        transport = appInfo.logBaseUrl.length
            ? new HTTPTransport_1.HTTPTransport(formatter, appInfo.logBaseUrl)
            : new ConsoleTransport_1.ConsoleTransport(formatter);
    }
    logger = new Logger_1.SystemLogger({ transport: transport });
    return logger;
}
exports.getSystemLogger = getSystemLogger;
//# sourceMappingURL=interface.js.map